import { render, staticRenderFns } from "./PlatformMonthlyRentImport.vue?vue&type=template&id=3cb1c73c&scoped=true"
import script from "./PlatformMonthlyRentImport.vue?vue&type=script&lang=js"
export * from "./PlatformMonthlyRentImport.vue?vue&type=script&lang=js"
import style0 from "./PlatformMonthlyRentImport.vue?vue&type=style&index=0&id=3cb1c73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb1c73c",
  null
  
)

export default component.exports